export default "__VITE_ASSET__DeehpkuE__"